/* eslint-disable no-dupe-keys */
/* eslint-disable max-len */
/**
 * 1.footer: English/Chinese environment copyright, privacy policy, and user agreement;
 * If a variable similar to 'year' is configured, the format is ES6 template string format;
 * Can be configured with any format of plain text, text with HTML tags, text with variables, and text with variables with HTML tags.
 * 2.versionDropdown: The version list displayed in the version drop-down box for each project,
 * regardless of the current version or language, displays the configured content;
 * Compatible with previous logic, if a project or a project in a certain language is not configured here,
 * it will be displayed according to the original logic of read the docs.
 * Note: If there is a connector in the repo name, such as repo: data quality, it should be written as' data quality '
 * 3. bannerContent: The content displayed by the banner is not configured to display the banner.
 */
import zhContext from '~/themeLocale/zh-CN.js';
import enContext from '~/themeLocale/en-US.js';

export const footer = {
  en: `© ${new Date().getFullYear()} Univers. All Rights Reserved.   |   <a href='https://developer.enos-iot.com/privacy-policy/' style="color: #8A8B99;">${enContext.THEME.PRIVACY_POLICY}</a>   <a href='https://developer.enos-iot.com/user-agreement/' style="color: #8A8B99;">${enContext.THEME.USER_AGREEMENT}</a>`,
  zh_CN: `© ${new Date().getFullYear()} 远景智能版权所有。   |   <a href='https://developer.enos-iot.com/zh_CN/privacy-policy/' style="color: #8A8B99;">${zhContext.THEME.PRIVACY_POLICY}</a>   <a href='https://developer.enos-iot.com/zh_CN/user-agreement/' style="color: #8A8B99;">${zhContext.THEME.USER_AGREEMENT}</a>`
};

export const versionDropdown = {
  dtv: {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', 'preview']
  },
  sso: {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', 'preview']
  },
  maf: {
    en: ['2.4.4', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  eoc: {
    en: ['2.4.0'],
    zh_CN: ['2.4.0']
  },
  'app-portal': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'alarm-management': {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  alert: {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'alert-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'data-quality': {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  'metric-management': {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  'metric-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  'data-asset-catalog': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'data-catalog-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', 'preview']
  },
  control: {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  cds: {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  reporting: {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  wmt: {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  monitor: {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  'reporting-api': {
    en: ['3.0.0', '2.4.4', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', 'preview']
  },
  'cds-api-app': {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  'app-development': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'onboarding-tool': {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  'onboarding-tool-api': {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  'device-integration': {
    en: ['2.4.4', '2.4.0', '2.3.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', 'preview']
  },
  enos: {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  dcm: {
    en: ['2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'device-connection': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'device-provisioning': {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  'notification-mgmt': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', 'preview']
  },
  api: {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'model-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'asset-tree-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'asset-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'connection-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'iam-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'dps-api': {
    en: ['2.4.4', '2.4.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', 'preview']
  },
  'configuration-center': {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  apim: {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'data-standards': {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  'data-asset-mgmt': {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  'data-sharing': {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  'schedule-center': {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  'data-policy': {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  'data-source-reg-app': {
    en: ['3.0.0', '2.4.4', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', 'preview']
  },
  'data-source-reg': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'data-archiving': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'data-subscription': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'time-series-data': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'enos-edge': {
    en: ['2.4.6', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.6', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'edge-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'wmt-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', 'preview']
  },
  'app-register-api': {
    en: ['3.0.0', '2.4.4', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', 'preview']
  },
  'app-portal-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'batch-processing-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'data-federation-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'tsdb-data-api': {
    en: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['3.0.0', '2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'tsdb-policy-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  'stream-processing-api': {
    en: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview'],
    zh_CN: ['2.4.4', '2.4.0', '2.3.0', '2.2.0', '2.1.0', 'preview']
  },
  dmaas: {
    en: ['2.4.4', 'preview'],
    zh_CN: ['2.4.4', 'preview']
  },
  'modelling-tool': {
    en: ['3.0.0', 'preview'],
    zh_CN: ['3.0.0', 'preview']
  },
  'data-subscription-api': {
    en: ['3.0.0', 'preview'],
    zh_CN: ['3.0.0', 'preview']
  },
  'data-download-api': {
    en: ['3.0.0', 'preview'],
    zh_CN: ['3.0.0', 'preview']
  }
};

export const bannerContent = {
  en: enContext.THEME.BANNER_TEXT,
  zh_CN: zhContext.THEME.BANNER_TEXT
};
